import { action, makeObservable, observable, runInAction } from 'mobx';

import { FileType, IFileBase } from 'shared/entities/file';
import { apiUrls } from 'shared/entities/domain';
import { IRootStore } from 'shared/entities/store/rootStore';
import { AreaSize } from 'shared/entities/geometry';

export default class FileBaseModel implements IFileBase {
  id: string;
  fileType: FileType;
  title: string;
  prevTitle: string;
  preview: string | null;
  size: number;
  date: Date;
  url: string;
  extension: string;
  extra: any;
  areaSize: AreaSize | null;
  duration: number | null;

  rootStore: IRootStore;

  constructor(
    {
      id,
      date,
      fileType,
      size,
      title,
      preview,
      url,
      extension,
      extra,
      areaSize,
      duration
    }: IFileBase,
    rootStore: IRootStore
  ) {
    this.id = id;
    this.fileType = fileType;
    this.date = date;
    this.size = size;
    this.title = title;
    this.prevTitle = title;
    this.preview = preview;
    this.url = url;
    this.extension = extension;
    this.extra = extra;
    this.areaSize = areaSize;
    this.duration = duration;

    this.rootStore = rootStore;

    makeObservable(this, {
      preview: observable,
      title: observable,
      prevTitle: observable,

      setTitle: action
    });
  }

  setTitle = (value: string): void => {
    this.title = value;
  };

  async rename(): Promise<void> {
    if (this.prevTitle === this.title) {
      return;
    }
    if (!this.title) {
      this.title = this.prevTitle;
      return;
    }
    const { isError } = await this.rootStore.networkStore.api<BaseResponse>(
      apiUrls.ATTACHMENTS_RENAME,
      {
        method: 'POST',
        data: {
          _id: this.id,
          filename: this.title
        }
      }
    );

    runInAction(() => {
      if (!isError) {
        this.prevTitle = this.title;
      } else {
        this.title = this.prevTitle;
      }
    });
  }
}
